import React, { useState } from 'react'

import { Box, colors, Grid, Typography } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import { LoadingFeedback } from 'components'
import { Form, ResendEmail } from './components'
import { JourneyRecaptcha } from '../../components'

import useSupplierJourney from 'hooks/useSupplierJourney'
import useSnackbar from 'hooks/useSnackbar'
import useAuthSupplier from 'hooks/useAuthSupplier'

import helpers from 'helpers'
import * as service from 'service'
import useStyles from './styles'

const TwoFactorAuthenticationStep = () => {
  const [isLoading, setIsLoading] = useState(false)

  const snackbar = useSnackbar()
  const classes = useStyles()
  const { handleSubmit } = useFormContext()
  const {
    disableRecaptcha,
    handleAcceptedRecaptcha,
    recaptcha,
    recaptchaRef,
    resetRecaptcha,
    companySupplierToken,
    user,
    accessToken,
  } = useSupplierJourney()
  const { loadDataWithAnimation, isLoading: isAuthSupplierLoading } =
    useAuthSupplier()

  const onSubmit = async (data) => {
    try {
      setIsLoading(true)

      const response = await service.supplierPortal.auth.login({
        token: companySupplierToken,
        code: data.code,
        accessToken,
        recaptcha,
      })

      service.supplierPortal.auth.setToken(response?.data?.authToken)
      service.supplierPortal.auth.setCompanySupplierToken(companySupplierToken)

      await loadDataWithAnimation()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao validar código de verificação. Tente novamente.',
        variant: 'error',
      })
    } finally {
      resetRecaptcha()
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading || isAuthSupplierLoading} />
      <Grid container spacing={6} justifyContent="center">
        <Grid item xs={12} md={8}>
          <Typography
            variant="h2"
            color="primary"
            style={{ textAlign: 'center' }}
          >
            Duplo Fator de Autenticação
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <form id="form-register" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} md={8}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  border={`1px solid ${colors.grey[300]}`}
                  gridGap={3}
                  px={3}
                  py={2}
                  borderRadius={4}
                >
                  <Typography variant="h4" color="textPrimary">
                    Enviamos um código de verificação no seu e-mail{' '}
                    <strong className={classes.highlightedText}>
                      {user?.email}
                    </strong>
                  </Typography>

                  <Form />
                  <ResendEmail />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={8}
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <JourneyRecaptcha
                  recaptchaRef={recaptchaRef}
                  onChange={handleAcceptedRecaptcha}
                  onExpired={disableRecaptcha}
                  onErrored={disableRecaptcha}
                />
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </>
  )
}

export default TwoFactorAuthenticationStep
